import type { nodeNewExecutor } from "~/js/utilities/changeNodeExecutorOnCustom";

export const soraExtractExecutor: nodeNewExecutor = (node, layout, initialExecutor) => {
	initialExecutor(node, layout);

	node.getAdditionalParamsForTask = (jsonData) => {
		if (!jsonData.inputs || !Array.isArray(jsonData.inputs)) jsonData.inputs = [];

		jsonData.inputs.push({
			name: "task_id",
			value: `${node.meta.fromTaskID}`,
			type: "text"
		});
		jsonData.inputs.push({
			name: "image_num",
			value: `${(node.meta.fromImageIndex ?? 0) + 1}`,
			type: "text"
		});
	};
};
